import React, { useState, useEffect } from 'react';
import { useProfileContext } from '../../../ProfileDetailContext';
import { Grid, TextField, Divider, FormControl, IconButton, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Button, FormHelperText, CircularProgress } from '@mui/material';
import { SkillItemForServices } from './AddSection';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";
import useApi from '../../../Utilities/useAPI';
import { DeleteLightBox } from '../ProfessionalProfile';
import PreviewFileItem from '../../../Utilities/PreviewFileItem';
import DeleteIcon from '@mui/icons-material/Delete';
import { v4 as uuidv4 } from 'uuid';
import { ERRORS, MAX_DESC_LENGTH } from '../../../../config/constant';
import { validateDateRange } from '../../../Utilities/ValidationFunctions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { deleteProjectReducer, getProjecteReducer, postProjecteBlobReducer } from '../../../../Redux/Reducers/ProfileReducer';
import { useQuantityContext } from '../../../QuantityContext';

const AddProject = ({ open, onClose, isEditing, editProjectIndex, handleGenerateDescription, handleSuccess, handleFailure, projectDetails }) => {
    // const {
    //  projectList, 
    // setprojectList,
    // setEditProjectIndex, setAddSection } = useProfileContext();

    // console.log("Project list", projectList, "index", editProjectIndex);
    // const [projectList, setprojectList] = useState([]);
    const { handleInfo } = useQuantityContext();
    const { callApiFunction } = useApi();

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentYear = new Date().getFullYear();
    const years = Array.from(
        { length: currentYear - 1970 + 1 },
        (_, index) => currentYear - index
    );

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false)
    const [currentProject, setCurrentProject] = useState({
        id: projectDetails?.id || '',
        projectName: projectDetails?.project_name || '',
        projectDescription: projectDetails?.project_description || '',
        startMonth: projectDetails?.start_month || '',
        startYear: projectDetails?.start_year || '',
        endMonth: projectDetails?.end_month || '',
        endYear: projectDetails?.end_year || '',
        currentlyWorking: projectDetails?.is_current_project || false,
        attachments: projectDetails?.attachments || [],
        isPublic: projectDetails?.is_public || true
    })
    const [isProjectDelete, setIsProjectDelete] = useState(false);
    const dispatch = useDispatch();
    const ProjectBlob = useSelector((state) => state?.ProfileArray?.projectBlob);


    const resetCurrentProject = () => {
        setCurrentProject({
            id: '',
            projectName: '',
            projectDescription: '',
            startMonth: '',
            startYear: '',
            endMonth: '',
            endYear: '',
            currentlyWorking: false,
            attachments: [],
            isPublic: true,
        });
        setErrors({
            projectName: false,
            endMonthInvalid: false,
            endYearInvalid: false
        });
    };


    useEffect(() => {
        if (isEditing === null) {
            // setCurrentProject(projectList[editProjectIndex]);
            resetCurrentProject();
        }
        // else {

        // }
    }, [isEditing, editProjectIndex]);




    const updateCurrentProject = (updatedField) => { //with both Key and Pair
        setCurrentProject((prevDetails) => ({
            ...prevDetails,
            ...updatedField,
        }));
    };

    const updateCurrentAttachments = (newAttachment) => {
        const attachmentWithId = { ...newAttachment, id: uuidv4() };
        setCurrentProject((prevState) => ({
            ...prevState,
            attachments: [...(prevState.attachments || []), attachmentWithId],
        }));
    };

    const handleRemoveAttachment = (id) => {
        // console.log('Entered removeProjectAttachments to delete id', id, currentProject?.attachments);
        setCurrentProject((prevState) => ({
            ...prevState,
            attachments: prevState.attachments?.map((attachment) =>
                attachment?.id === id ? { ...attachment, toBeDeleted: true } : attachment
            ),
        }));
    };

    const handleProjectItems = (fieldName) => (event) => {
        const newValue = event.target.value;
        const updatedField = { [fieldName]: newValue };
        const updatedProject = { ...currentProject, ...updatedField };

        updateCurrentProject(updatedField);
        // Clear error when user starts typing
        setErrors({
            ...errors,
            [fieldName]: false,
        });

        // Validate date range only if both startYear and endYear are provided
        const startYearProvided = updatedProject.startYear && updatedProject.startYear !== '';
        const endYearProvided = updatedProject.endYear && updatedProject.endYear !== '';
        const startMonthProvided = updatedProject.startMonth && updatedProject.startMonth !== '';
        const endMonthProvided = updatedProject.endMonth && updatedProject.endMonth !== '';

        let isValidDateRange = true;

        if (startYearProvided && endYearProvided) {
            isValidDateRange = validateDateRange(
                updatedProject.startYear,
                updatedProject.startMonth,
                updatedProject.endYear,
                updatedProject.endMonth
            );
        }

        // Set errors based on validation
        setErrors(prevErrors => ({
            ...prevErrors,
            endMonthInvalid: !isValidDateRange && endMonthProvided,
            endYearInvalid: !isValidDateRange && endYearProvided
        }));
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        updateCurrentProject({ currentlyWorking: checked });
        if (checked) {
            updateCurrentProject({ endMonth: 'Present', endYear: 'Present' });
            setErrors(prevState => ({
                ...prevState,
                endMonthInvalid: false,
                endYearInvalid: false
            }))
        } else {
        }
    };

    const requiredFields = ['projectName'];

    const [errors, setErrors] = useState({
        projectName: false,
        endMonthInvalid: false,
        endYearInvalid: false
    });

    // --------------- API Calling Functions ----------------------

    const handleSave = async (e) => {
        e.preventDefault();
        if (submitting) return;
        const newErrors = { ...errors };

        requiredFields.forEach(field => {
            if (!currentProject[field]) {
                newErrors[field] = true;
            } else {
                newErrors[field] = false;
            }
        });

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(error => error);

        if (hasErrors) return;
        setSubmitting(true);
        try {
            const endpoint = 'projectsCreateUpdate';
            const { id, projectName, projectDescription, startMonth, startYear, endMonth, endYear, currentlyWorking, attachments, isPublic } = currentProject;
            const projectAttachments = attachments
                ?.filter(attachment => !attachment.toBeDeleted) // Exclude attachments marked for deletion
                ?.map((attachment) => ({
                    document_name: attachment?.name || attachment?.document_name,
                    document_link: attachment?.data || attachment?.document_url,
                    document_type: attachment?.type || attachment?.document_type,
                    document_meta: {
                        document_size: attachment.size || attachment?.size
                    },
                    is_verified: false,
                    is_public: false
                }));

            const formData = new FormData();

            // Append non-file payload data
            formData.append("id", id);
            formData.append("project_name", projectName);
            formData.append("project_description", projectDescription);
            formData.append("start_month", startMonth);
            formData.append("start_year", startYear);
            formData.append("end_month", endMonth);
            formData.append("end_year", endYear === "Present" ? new Date().getFullYear() : endYear);
            formData.append("is_current_project", currentlyWorking || false);
            formData.append("is_public", isPublic);

            // console.log("file DATA", projectAttachments);


            if (projectAttachments?.length > 0) {
                setLoading(true);
                handleInfo("Please wait to complete the process.");

                for (let i = 0; i < projectAttachments?.length; i++) {
                    try {
                        const fileName = projectAttachments[i].document_name || "Unnamed File"; // Default name
                        const fileType = projectAttachments[i].document_type;
                        const documentLink = projectAttachments[i].document_link;
                        const fileSize = projectAttachments[i].document_meta?.document_size;
                        // console.log(`File: ${fileName}, Type: ${fileType}, Link: ${documentLink}`);

                        if (fileType === "url") {
                            const websiteLinks = {
                                "document_name": projectAttachments[i]?.document_name,
                                "document_link": projectAttachments[i]?.document_link,
                                "document_type": projectAttachments[i]?.document_type,
                                "document_meta": {
                                    "document_size": projectAttachments[i]?.document_meta?.document_size || 0
                                },
                                "is_verified": projectAttachments[i]?.is_verified,
                                "is_public": projectAttachments[i]?.is_public
                            };

                            formData.append("website_links[]", JSON.stringify(websiteLinks));
                        } else {
                            // Fetch and append file attachments
                            try {
                                const response = await fetch(documentLink);
                                const blob = await response.blob();
                                formData.append("attachments", blob, fileName);
                            } catch (error) {
                                console.log("Error", error);
                            }

                        }

                    } catch (error) {
                        console.error("Error fetching attachment:", error);
                    }
                }
                setLoading(false);
            }

            try {
                // const response = await callApiFunction(endpoint, payload);
                setLoading(true);
                const response = await dispatch(postProjecteBlobReducer(formData))
                if (response?.payload?.statusCode === 200) {
                    await dispatch(getProjecteReducer());
                    const newId = ProjectBlob?.id;
                    // if (editProjectIndex !== null) {
                    //     const updatedProjectList = projectList?.map((project, index) =>
                    //         index === editProjectIndex ? currentProject : project
                    //     );
                    //     setprojectList(updatedProjectList);
                    //     setEditProjectIndex(null);
                    // } else {
                    //     const newProject = { ...currentProject, id: newId };
                    //     setprojectList((prevList) => [...prevList, newProject]);
                    // }
                    resetCurrentProject();
                    // console.log("After click on the save button.")
                    onClose();
                    handleSuccess("Successfully Added");
                    // handleSuccess();

                    // setAddSection((prevState) => ({
                    //     ...prevState,
                    //     professionalProject: true
                    // }))
                }
                // else {
                //     console.log("Failed POST for Project");
                //     handleFailure();
                // }
            } catch (error) {
                console.log("Error Saving Project Details: ", error);
                // handleFailure();
            } finally {
                setLoading(false);
            }
        } finally {
            setSubmitting(false);
        }
    }; // <-- Added missing closing brace here

    const handleDelete = async () => {
        const endpoint = 'projectsDelete';
        const { id } = currentProject;
        const params = { id };
        try {
            // const response = await callApiFunction(endpoint, params);
            const response = await dispatch(deleteProjectReducer(id));
            if (response?.payload?.statusCode === 200) {
                await dispatch(getProjecteReducer());
                onClose();
                setIsProjectDelete(false);
                // if (editProjectIndex !== null) {
                //     const updatedProjectList = projectList.filter((project, index) => index !== editProjectIndex);
                //     setprojectList(updatedProjectList);
                //     setEditProjectIndex(null);
                // }
                resetCurrentProject();
                // setAddSection((prevState) => ({
                //     ...prevState,
                //     professionalProject: true
                // }));
                handleSuccess('', 'Delete');
            } else {
                console.log('Could not DELETE project', response);
                handleFailure('', 'Delete');
            }
        } catch (error) {
            console.log('TRY for DELETE failed', error, params);
            handleFailure('', 'Delete');
        }
    }

    return (
        open && currentProject && (
            <div className="lightbox-overlay">
                <div className="lightbox-content-2 p-0 thin-lightbox">
                    <div style={{ textAlign: "left" }}>
                        <div className="d-flex justify-content-between px-4 pt-4">
                            <div className="card-edit-info-heading">
                                <div className="profile-modal-heading1 mb-2">{isEditing ? 'Edit Project' : 'Add Project'}</div>
                                <div className="sub-text-lightbox">{isEditing ? 'Edit your Project Details' : 'Add your Project Details'}</div>
                            </div>
                            <IconButton className="modal-close-button" onClick={onClose}>
                                <CloseRounded />
                            </IconButton>
                        </div>

                        <Divider className='my-2' sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />

                        <div className="px-4 pb-4 pt-2">
                            <div className="my-2 user-details-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            name="projectName"
                                            label="Project Title"
                                            fullWidth
                                            value={currentProject?.projectName}
                                            onChange={handleProjectItems('projectName')}
                                            required
                                            error={errors?.projectName}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            multiline
                                            rows={3}
                                            name="projectDescription"
                                            label="Description"
                                            placeholder="Description (500 characters Maximum)"
                                            autoComplete="off"
                                            variant="outlined"
                                            fullWidth
                                            inputProps={{ maxLength: MAX_DESC_LENGTH }}
                                            value={currentProject?.projectDescription}
                                            onChange={handleProjectItems('projectDescription')}
                                        />

                                        <div className="d-flex justify-content-end align-items-start my-2">
                                            {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                                            <Button
                                                variant="outlined"
                                                sx={{ color: "#0044C6" }}
                                                className="ai-rewrite-button"
                                                onClick={() => handleGenerateDescription(
                                                    {
                                                        projectTitle: currentProject?.projectName,
                                                        description: currentProject?.projectDescription,
                                                    },
                                                    "project",
                                                    "projectDescription",
                                                    updateCurrentProject
                                                )
                                                }
                                                disabled={!currentProject?.projectName}
                                                startIcon={<AiLogo />}
                                            >
                                                Generate
                                            </Button>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <h2 className="headingforContent text-left mt-1 p-0">Duration</h2>
                                        {/* <p className='text-left subtitle_services_section m-0 p-0'>Update the Days of your Working</p> */}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="startMonth-label">Month</InputLabel>
                                            <Select
                                                labelId="startMonth-label"
                                                value={currentProject?.startMonth ?? ''}
                                                onChange={handleProjectItems('startMonth')}
                                                label="Month"
                                                className="text-left"
                                            >
                                                {months?.map((month, index) => (
                                                    <MenuItem key={index} value={month}>
                                                        {month}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="startYear-label">Year</InputLabel>
                                            <Select
                                                labelId="startYear-label"
                                                value={currentProject?.startYear ?? ''}
                                                onChange={handleProjectItems('startYear')}
                                                label="Year"
                                                className="text-left"
                                            >
                                                {years?.map((year, index) => (
                                                    <MenuItem key={index} value={year}>
                                                        {year}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth error={errors?.endMonthInvalid || errors?.endYearInvalid}>
                                            <InputLabel id="endMonth-label">Month</InputLabel>
                                            <Select
                                                labelId="endMonth-label"
                                                value={currentProject?.endMonth || ''}
                                                onChange={handleProjectItems('endMonth')}
                                                label="Month"
                                                className="text-left"
                                                disabled={currentProject?.currentlyWorking}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {currentProject?.currentlyWorking &&
                                                    <MenuItem value='Present'>
                                                        Present
                                                    </MenuItem>
                                                }
                                                {months?.map((month, index) => (
                                                    <MenuItem key={index} value={month}>
                                                        {month}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors.endMonthInvalid && errors.endYearInvalid &&
                                                <FormHelperText>{ERRORS.invalidDate}</FormHelperText>
                                            }
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth error={errors?.endMonthInvalid || errors?.endYearInvalid}>
                                            <InputLabel id="endYear-label">Year</InputLabel>
                                            <Select
                                                labelId="endYear-label"
                                                // value={currentProject?.endYear || ''}
                                                value={currentProject?.currentlyWorking ? 'Present' : (currentProject?.endYear ?? '')}
                                                onChange={handleProjectItems('endYear')}
                                                label="Year"
                                                className="text-left"
                                                disabled={currentProject?.currentlyWorking}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {currentProject?.currentlyWorking &&
                                                    <MenuItem value='Present'>
                                                        Present
                                                    </MenuItem>
                                                }
                                                {years?.map((year, index) => (
                                                    <MenuItem key={index} value={year}>
                                                        {year}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <div className='mt-2'>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    // checked={currentProject?.currentlyWorking}
                                                    checked={Boolean(currentProject?.currentlyWorking)}
                                                    onChange={handleCheckboxChange}
                                                    name="current-pursuing"
                                                />
                                            }
                                            label='Currently Working on this project'
                                            className='checkbox-container'
                                        />
                                    </div>

                                    <Grid item xs={12}>
                                        <h2 className="headingforContent text-left mt-1 p-0">Attachments</h2>
                                        <div className='text-left subtitle_services_section mt-1 mb-2'>Upload Media like images, documents, sites or presentations</div>
                                        <SkillItemForServices maxSize={5000000} updateAttachments={updateCurrentAttachments} />
                                        {currentProject?.attachments
                                            ?.filter(attachment => !attachment.toBeDeleted) // Exclude attachments marked for deletion
                                            ?.map((attachment, index) => (
                                                <div key={index} className="add-project-modal my-3">
                                                    {typeof attachment === 'string' ? (
                                                        <a href={attachment}>
                                                            <div className="design-lighter-textNew">{attachment}</div>
                                                        </a>
                                                    ) : (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="Documents-Attachments">
                                                                <PreviewFileItem file={attachment} fontColor="#00000099" />
                                                            </div>
                                                            <IconButton onClick={() => handleRemoveAttachment(attachment.id)}>
                                                                <DeleteIcon />
                                                            </IconButton >
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </Grid>
                                </Grid>
                            </div>

                            {isEditing ?
                                <div className="mt-2 d-flex justify-content-between">
                                    <Button sx={{ color: '#0044C6' }} onClick={() => { setIsProjectDelete(true) }}>
                                        Delete Project
                                    </Button>
                                    <Button variant="contained" sx={{ backgroundColor: '#0044C6' }} onClick={handleSave}>
                                        Save
                                    </Button>
                                </div>
                                :
                                <div className="mt-2 d-flex justify-content-end">
                                    <Button variant="contained" sx={{ backgroundColor: '#0044C6' }} onClick={handleSave} disabled={loading || submitting}>
                                        {/* Add */}
                                        {submitting ? (
                                            <span className="d-flex align-items-center">
                                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                                Adding...
                                            </span>
                                        ) : (
                                            "Add"
                                        )}
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {isProjectDelete &&
                    <DeleteLightBox Title="Project" Label="Do you really want to remove this Project?" LightBoxCloseFunction={setIsProjectDelete}
                        DeleteFunction={handleDelete} clearFields={undefined} />
                }
            </div>
        )
    );
};

export default AddProject;